import { Alert } from '@/components/ui/Alert'

export interface CompletenessBannerProps {
  cappedCaptures: string[]
  totalCaptures: number
}

/**
 * The portal displays at most 300 records per search and drops the overflow
 * silently, so a search of a common surname looks complete when it is not.
 * Whenever any loaded capture hit that cap, say so plainly and say what to do.
 */
export function CompletenessBanner({
  cappedCaptures,
  totalCaptures,
}: CompletenessBannerProps) {
  if (cappedCaptures.length === 0) return null

  return (
    <Alert tone="warning" title="This data set is incomplete">
      <p>
        {cappedCaptures.length} of {totalCaptures} source searches hit the
        portal&rsquo;s 300-record display cap, so matching judgments exist that are
        not stored here. Split those searches (by judgment status, by decade, or
        by county) and ingest the parts.
      </p>
      <details className="group mt-2">
        <summary className="w-fit cursor-pointer text-xs text-ink-muted transition-colors hover:text-ink-secondary">
          <span className="group-open:hidden">
            Which {cappedCaptures.length === 1 ? 'search' : 'searches'}?
          </span>
          <span className="hidden group-open:inline">Hide</span>
        </summary>
        <ul className="mt-1.5 flex flex-wrap gap-1.5">
          {cappedCaptures.map((label) => (
            <li
              key={label}
              className="ident rounded-md border border-line bg-surface-raised px-1.5 py-0.5 text-xs text-ink-secondary"
            >
              {label}
            </li>
          ))}
        </ul>
      </details>
    </Alert>
  )
}
